export interface ProfileCredentialId {
  id: string;
  titleKey: string;
  metaKey: string;
}

/** Demo credentials shown on the profile diplomas/certificates tab. */
export const demoCertificates: readonly ProfileCredentialId[] = [
  { id: "cert-hygiene", titleKey: "profile.demo.certHygieneTitle", metaKey: "profile.demo.certHygieneMeta" },
  { id: "cert-bhv", titleKey: "profile.demo.certBhvTitle", metaKey: "profile.demo.certBhvMeta" },
];

export const demoDiplomas: readonly ProfileCredentialId[] = [
  { id: "diploma-mbo2", titleKey: "profile.demo.diplomaMboTitle", metaKey: "profile.demo.diplomaMboMeta" },
];
